const { fetchJSON } = window.BAO.Utils

class StoreSwitcher extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    /* Force redirect - Start */
    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    }
    /* Force redirect - End */

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.countryParam = params.country

    if (this.countryParam !== null) {
      this.setStorageFromURL(this.countryParam)
    }
    /* ?country= in URL check - End */

    if (this.countryParam !== null) {
      const countryCode = this.countryParam

      this.setupCountrySwitcher(countryCode)
      this.updateShippingLabel(countryCode)
    } else if (!this.noLocationStored) {
      const countryCode = window.localStorage.getItem(this.userLocationName)

      this.setupCountrySwitcher(countryCode)
      this.updateShippingLabel(countryCode)
    } else {
      fetchJSON('/browsing_context_suggestions.json', {
        method: 'GET',
      }).then((res) => {
        const countryCode = res.detected_values.country.handle

        this.setupCountrySwitcher(countryCode)
        this.updateShippingLabel(countryCode)
      })
    }
  }

  forceRedirect () {
    fetchJSON('/browsing_context_suggestions.json', {
      method: 'GET',
    }).then((res) => {
      const userCountry = res.detected_values.country.handle

      let windowPathname = window.location.pathname

      const subdomainFolder = windowPathname.split('/').filter((item) => {
        return item.indexOf('en-') > -1
      })

      if (subdomainFolder) {
        windowPathname = windowPathname
          .replace(subdomainFolder, '')
          .replace('//', '/')
      }

      window.location.href = `${
        this.sites[this.countries[userCountry].site].url
      }${windowPathname}?country=${userCountry}`
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onModalSelectChange = this.onModalSelectChange.bind(this)
    this.onModalConfirmClick = this.onModalConfirmClick.bind(this)

    this.onDrawerSelectChange = this.onDrawerSelectChange.bind(this)
    this.onDrawerConfirmClick = this.onDrawerConfirmClick.bind(this)

    if (this.els?.select?.exists) {
      this.listeners.add(
        this.els.select.element,
        'change',
        this.onModalSelectChange,
      )
    }

    if (this.els?.confirm?.exists) {
      this.els.confirm.elements.forEach((confirmEl) => {
        this.listeners.add(confirmEl, 'click', this.onModalConfirmClick)
      })
    }

    if (this.externalEls?.select?.exists) {
      this.listeners.add(
        this.externalEls.select.element,
        'change',
        this.onDrawerSelectChange,
      )
    }

    if (this.externalEls?.confirm?.exists) {
      this.externalEls.confirm.elements.forEach((confirmEl) => {
        this.listeners.add(confirmEl, 'click', this.onDrawerConfirmClick)
      })
    }
  }

  onDrawerConfirmClick (event) {
    event.preventDefault()

    const select = this.externalEls?.select?.element
    if (!select?.value) return

    window.location.href = select.value
  }

  onDrawerSelectChange (event) {
    const select = event.target
    const option = select.options[select.selectedIndex]

    const countryCode = option.dataset.country
    const countryName = option.textContent
    const currency = option.dataset.currency

    /* Update trigger text */
    if (this.externalEls?.['drawer-text']?.exists) {
      this.externalEls['drawer-text'].elements.forEach((el) => {
        el.innerHTML = `${countryName} / ${currency}`
      })
    }

    /* Update flag */
    const flagUrl = this.getFlagUrl(countryCode)

    if (this.externalEls?.['drawer-flag']?.exists) {
      this.externalEls['drawer-flag'].elements.forEach((flagEl) => {
        flagEl.innerHTML = `
        <img
          src="${flagUrl}"
          width="30"
          height="30"
          alt=""
          loading="lazy"
        >
      `
      })
    }

    /* Enable confirm */
    if (this.externalEls?.confirm?.exists) {
      this.externalEls.confirm.element.disabled = false
    }
  }

  onModalSelectChange (event) {
    const select = event.target
    const option = select.options[select.selectedIndex]

    const countryCode = option.dataset.country
    const countryName = option.textContent
    const currency = option.dataset.currency

    /* Update trigger text */
    if (this.els?.text?.exists) {
      this.els.text.elements.forEach((el) => {
        el.innerHTML = `${countryName} / ${currency}`
      })
    }

    /* Update flag */
    const flagUrl = this.getFlagUrl(countryCode)

    if (this.els?.flag?.exists) {
      this.els.flag.elements.forEach((flagEl) => {
        flagEl.innerHTML = `
        <img
          src="${flagUrl}"
          width="30"
          height="30"
          alt=""
          loading="lazy"
        >
      `
      })
    }
  }

  onModalConfirmClick (event) {
    event.preventDefault()

    const select = this.els?.select?.element
    if (!select?.value) return

    window.location.href = select.value
  }

  updateShippingLabel (countryCode) {
    if (!countryCode) return

    const upperCountryCode = countryCode.toUpperCase()
    const country = this.countries[upperCountryCode]

    if (!country) return

    const { name, currency } = country
    const label = `${name} / ${currency}`
    const flagUrl = this.getFlagUrl(upperCountryCode)

    /* Modal trigger text */
    if (this.els?.text?.exists) {
      this.els.text.elements.forEach((el) => {
        el.innerHTML = label
      })
    }

    /* Modal trigger flag */
    if (this.els?.flag?.exists) {
      this.els.flag.elements.forEach((flagEl) => {
        flagEl.innerHTML = `
        <img
          src="${flagUrl}"
          width="30"
          height="30"
          alt=""
          loading="lazy"
        >
      `
      })
    }

    /* Drawer trigger text */
    if (this.externalEls?.['drawer-text']?.exists) {
      this.externalEls['drawer-text'].elements.forEach((el) => {
        el.innerHTML = label
      })
    }

    /* Drawer trigger flag */
    if (this.externalEls?.['drawer-flag']?.exists) {
      this.externalEls['drawer-flag'].elements.forEach((flagEl) => {
        flagEl.innerHTML = `
        <img
          src="${flagUrl}"
          width="30"
          height="30"
          alt=""
          loading="lazy"
        >
      `
      })
    }

    /* Footer trigger text */
    if (this.externalEls?.['trigger-text']?.exists) {
      this.externalEls['trigger-text'].elements.forEach((el) => {
        el.innerHTML = label
      })
    }

    /* Footer trigger flag */
    if (this.externalEls?.['trigger-flag']?.exists) {
      this.externalEls['trigger-flag'].elements.forEach((flagEl) => {
        flagEl.innerHTML = `
        <img
          src="${flagUrl}"
          width="30"
          height="30"
          alt=""
          loading="lazy"
        >
      `
      })
    }
  }

  setupCountrySwitcher (countryCode) {
    this.createOptions(countryCode)

    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }

    if (!this.noLocationStored) return

    if (this.countryParam !== null) return

    this.showModal()
    document.body.classList.add('util-SiteOverflowed')
  }

  createOptions (countryCode) {
    const modalSelect = this.els?.select?.element
    const drawerSelect = this.externalEls?.select?.element

    Object.entries(this.countries)
      .sort(([, a], [, b]) => a.name.localeCompare(b.name))
      .forEach(([code, value]) => {
        const { name, site, currency } = value
        const siteUrl = this.sites[site].url
        const isSelected = code.toLowerCase() === countryCode.toLowerCase()

        const optionHTML = `
      <option
        value="${siteUrl}${this.dataset.pageUrl}?country=${code}"
        data-country="${code}"
        data-currency="${currency}"
        ${isSelected ? 'selected' : ''}
      >
        ${name}
      </option>
    `

        if (modalSelect) {
          modalSelect.insertAdjacentHTML('beforeend', optionHTML)
        }
        if (drawerSelect) {
          drawerSelect.insertAdjacentHTML('beforeend', optionHTML)
        }
      })
  }

  createModalElement (code, site, isCurrentSite, country) {
    const siteUrl = this.sites[site].url

    return `<li class="mod-StoreSwitcher_Item">
      <a
        class="mod-StoreSwitcher_Link fz-15_120"
        href="${siteUrl}${this.dataset.pageUrl}?country=${code}"
        aria-current="${isCurrentSite ? 'true' : 'false'}"
        data-store-switcher-el="link"
      >
        ${country}
      </a>
    </li>`
  }

  createDrawerElement (code, site, isCurrentSite, country) {
    const siteUrl = this.sites[site].url

    return `<li class="drw-StoreSwitcher_Item">
      <a
        class="drw-StoreSwitcher_Link fz-15_120"
        href="${siteUrl}${this.dataset.pageUrl}?country=${code}"
        aria-current="${isCurrentSite ? 'true' : 'false'}"
        data-store-switcher-external-el="link"
      >
        ${country}
      </a>
    </li>`
  }

  setStorageFromURL (countryCode) {
    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !window.Shopify.designMode)
    )
  }

  get userLocationName () {
    return 'Gill-BAO-localization'
  }

  getFlagUrl (countryCode) {
    return `https://cdn.shopify.com/static/images/flags/${countryCode.toLowerCase()}.svg?width=30`
  }

  get sites () {
    return {
      ROW: {
        url: 'https://row.gillmarine.com',
      },
      UK: {
        url: 'https://gb.gillmarine.com',
      },
      US: {
        url: 'https://gillmarine.com',
      },
    }
  }

  get countries () {
    return window.theme.countries
  }
}

if (!customElements.get('store-switcher')) {
  customElements.define('store-switcher', StoreSwitcher, { extends: 'dialog' })
}
